import React, { useState, useEffect } from 'react';
import { Breadcrumb, Collapse, Select } from "antd";
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import ActivitySwitch from 'modules/layoutModule/components/ActivitySwitch/ActivitySwitch';
import {
  Form,
  Input,
  Button,
  Space,
  Skeleton,
  ConfigProvider,
  BackTop,
} from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';
import { useHistory } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';
import {
  savePlantScheduleRequest,
  getSpecificPlantScheduleRequest,
  getKnowledgeRequest,
} from 'modules/knowledgeModule/requests/knowledgeRequests';
import TextEditor from 'modules/layoutModule/components/TextEditor/TextEditor';
import FormFileUpload from 'modules/galleryModules/components/FormFileUpload';
import copyToClipboard from "helpers/copyToClipboard";

const { TextArea } = Input;
const { Panel } = Collapse;

const FertilizationScheduleEdit = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const history = useHistory();
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [isActivityDisabled, toggleActivityDisable] = useState(false);
  const [fileImage1, setFileImage1] = useState<string | null>(null);
  const [fileImage2, setFileImage2] = useState<string | null>(null);
  const [fileImage3, setFileImage3] = useState<string | null>(null);
  const [fileImage4, setFileImage4] = useState<string | null>(null);
  const [fileImage5, setFileImage5] = useState<string | null>(null);
  const [fileImage6, setFileImage6] = useState<string | null>(null);
  const [fileImage7, setFileImage7] = useState<string | null>(null);

  const [fileImage1Changed, changedFileImage1] = useState<boolean>(false);
  const [fileImage2Changed, changedFileImage2] = useState<boolean>(false);
  const [fileImage3Changed, changedFileImage3] = useState<boolean>(false);
  const [fileImage4Changed, changedFileImage4] = useState<boolean>(false);
  const [fileImage5Changed, changedFileImage5] = useState<boolean>(false);
  const [fileImage6Changed, changedFileImage6] = useState<boolean>(false);
  const [fileImage7Changed, changedFileImage7] = useState<boolean>(false);

  const [contentValue, setContentValue] = useState<string | undefined>('');
  const [content2Value, setContent2Value] = useState<string | undefined>('');
  const [content3Value, setContent3Value] = useState<string | undefined>('');
  const [content4Value, setContent4Value] = useState<string | undefined>('');
  const [content5Value, setContent5Value] = useState<string | undefined>('');

  const [file1, setFile1] = useState<string | null>(null);
  const [file1Changed, changedFile1] = useState<boolean>(false);

  const [file2, setFile2] = useState<string | null>(null);
  const [file2Changed, changedFile2] = useState<boolean>(false);

  const [file3, setFile3] = useState<string | null>(null);
  const [file3Changed, changedFile3] = useState<boolean>(false);

  const [file4, setFile4] = useState<string | null>(null);
  const [file4Changed, changedFile4] = useState<boolean>(false);

  const [file5, setFile5] = useState<string | null>(null);
  const [file5Changed, changedFile5] = useState<boolean>(false);

  const [plants, setPlants] = useState([]);

  useEffect(() => {
    toggleLoading(true);

    getKnowledgeRequest().then((response) => {
      if (response.data) {
        const sections = response.data.map(
          (section: { name: string; id: number }) => {
            return {
              label: section.name,
              value: section.id,
            };
          }
        );
        sections.unshift({ label: '', value: '' });
        setPlants(sections);
      }
    });

    getSpecificPlantScheduleRequest(id)
      .then((response) => {
        if (response) {
          toggleLoading(false);
          const { data } = response;

          setFields([
            {
              name: ['id'],
              value: data.rows.id,
            },
            {
              name: ['name'],
              value: data.rows.name,
            },
            {
              name: ['name2'],
              value: data.rows.name2,
            },
            {
              name: ['fileImage1'],
              value: data.rows.fileImage1,
            },
            {
              name: ['fileImage2'],
              value: data.rows.fileImage2,
            },
            {
              name: ['fileImage3'],
              value: data.rows.fileImage3,
            },
            {
              name: ['fileImage4'],
              value: data.rows.fileImage4,
            },
            {
              name: ['fileImage5'],
              value: data.rows.fileImage5,
            },
            {
              name: ['fileImage6'],
              value: data.rows.fileImage6,
            },
            {
              name: ['fileImage7'],
              value: data.rows.fileImage7,
            },
            {
              name: ['sortOrder'],
              value: data.rows.sortOrder,
            },
            {
              name: ['plants'],
              value: data.rows.plants,
            },
            {
              name: ['table1'],
              value: data.rows.table1,
            },
            {
              name: ['table2'],
              value: data.rows.table2,
            },
            {
              name: ['table3'],
              value: data.rows.table3,
            },
            {
              name: ['table4'],
              value: data.rows.table4,
            },
            {
              name: ['table5'],
              value: data.rows.table5,
            },
            {
              name: ['isActive'],
              value: data.rows.isActive || false,
            },
          ]);
          form.setFieldsValue({
            fileImage1: data.rows?.fileImage1,
            fileImage2: data.rows?.fileImage2,
            fileImage3: data.rows?.fileImage3,
            fileImage4: data.rows?.fileImage4,
            fileImage5: data.rows?.fileImage5,
            fileImage6: data.rows?.fileImage6,
            fileImage7: data.rows?.fileImage7,
            fileDownloadAll: data.rows?.fileDownloadAll,
            fileDownloadRed: data.rows?.fileDownloadRed,
            fileDownloadBlue: data.rows?.fileDownloadBlue,
            fileDownloadYellow: data.rows?.fileDownloadYellow,
            fileDownloadGreen: data.rows?.fileDownloadGreen,
          });

          setFileImage1(data.rows?.fileImage1);
          setFileImage2(data.rows?.fileImage2);
          setFileImage3(data.rows?.fileImage3);
          setFileImage4(data.rows?.fileImage4);
          setFileImage5(data.rows?.fileImage5);
          setFileImage6(data.rows?.fileImage6);
          setFileImage7(data.rows?.fileImage7);

          setContentValue(data.rows.descriptionAll);
          setContent2Value(data.rows.descriptionRed);
          setContent3Value(data.rows.descriptionBlue);
          setContent4Value(data.rows.descriptionYellow);
          setContent5Value(data.rows.descriptionGreen);

          setFile1(data.rows.fileDownloadAll);
          setFile2(data.rows.fileDownloadRed);
          setFile3(data.rows.fileDownloadBlue);
          setFile4(data.rows.fileDownloadYellow);
          setFile5(data.rows.fileDownloadGreen);

          if (data.rows.activitySwitchDisabled) {
            toggleActivityDisable(true);
          }
        } else {
          history.push('/representatives');
        }
      })
      .catch(() => {
        history.push('/representatives');
      });
  }, []);

  const onFinish = (values: any) => {
    toggleButtonLoading(true);
    savePlantScheduleRequest(values).then(() => {
      toggleButtonLoading(false);
    });
  };

  const onContentEdit = (value: string, field: string) => {
    setFields([
      {
        name: [field],
        value: value,
      },
    ]);
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const updateCover = (
    e: string,
    field: string,
    coverMethod: (value: string) => void,
    coverMethodChanged: (value: boolean) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
    coverMethodChanged(true);
  };

  const updateFile = (
    e: string,
    field: string,
    coverMethod: (value: string) => void,
    coverMethodChanged: (value: boolean) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
    coverMethodChanged(true);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Wiedza</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/fertilization-schedule">Harmonogramy</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/fertilization-schedule/${id}`}>Edycja wpisu</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <div className="site-layout-background">
          {loading && <Skeleton active />}
          {!loading && (
            <Form
              layout="vertical"
              fields={fields}
              onFinish={onFinish}
              form={form}
              validateMessages={validateMessages}
            >
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name="fileImage1"
                label="Piktogram biały"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage1}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage1',
                      setFileImage1,
                      changedFileImage1
                    )
                  }
                  isNew={fileImage1Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage1"
                  number={1}
                  hideTags
                  originalFile
                />
              </Form.Item>
              <Form.Item
                name="fileImage2"
                label="Piktogram zielony ciemny"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage2}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage2',
                      setFileImage2,
                      changedFileImage2
                    )
                  }
                  isNew={fileImage2Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage2"
                  number={2}
                  hideTags
                  originalFile
                />
              </Form.Item>

              <Form.Item
                name="name"
                label="Nazwa w sliderze"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item name="plants" label="Połącz z nawożeniem uprawy">
                <Select
                  showSearch
                  placeholder="Wybierz harmonogram nawożenia"
                  optionFilterProp="children"
                  options={plants}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      const label = option?.label as string;
                      return label.toLowerCase().includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>

              <Form.Item
                name="name2"
                label="Nazwa przycisku w nawożeniu uprawy"
              >
                <Input />
              </Form.Item>


              <fieldset className="fieldset no-bottom">
                <Form.Item
                  name="fileImage3"
                  label="Okładka (wszystkie nawozy)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <FormCoverUpload
                    cover={fileImage3}
                    setCover={(e) =>
                      updateCover(
                        e,
                        'fileImage3',
                        setFileImage3,
                        changedFileImage3
                      )
                    }
                    isNew={fileImage3Changed}
                    id={form.getFieldsValue()?.id}
                    field="fileImage3"
                    number={3}
                    hideTags
                    dontResize
                  />
                </Form.Item>
                <Form.Item
                  name="fileDownloadAll"
                  label="Plik do pobrania (wszystkie nawozy)"
                >
                  <FormFileUpload
                    file={file1}
                    setFile={(e) =>
                      updateFile(e, 'fileDownloadAll', setFile1, changedFile1)
                    }
                    id={form.getFieldsValue()?.id}
                    isNew={file1Changed}
                    field="file1"
                    number={1}
                  />
                </Form.Item>
                <Form.Item
                  name="descriptionAll"
                  label="Opis (wszystkie nawozy)"
                >
                  <TextEditor
                    initialValue={contentValue}
                    onChange={(value) => onContentEdit(value, 'descriptionAll')}
                    disableGallery
                  />
                </Form.Item>
              </fieldset>

              <fieldset className="fieldset no-bottom">
                <Form.Item
                  name="fileImage4"
                  label="Okładka (nawozy dwuskładnikowe)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <FormCoverUpload
                    cover={fileImage4}
                    setCover={(e) =>
                      updateCover(
                        e,
                        'fileImage4',
                        setFileImage4,
                        changedFileImage4
                      )
                    }
                    isNew={fileImage4Changed}
                    id={form.getFieldsValue()?.id}
                    field="fileImage4"
                    number={4}
                    hideTags
                    dontResize
                  />
                </Form.Item>
                <Form.Item
                  name="fileDownloadRed"
                  label="Plik do pobrania (nawozy dwuskładnikowe)"
                >
                  <FormFileUpload
                    file={file2}
                    setFile={(e) =>
                      updateFile(e, 'fileDownloadRed', setFile2, changedFile2)
                    }
                    id={form.getFieldsValue()?.id}
                    isNew={file2Changed}
                    field="file2"
                    number={2}
                  />
                </Form.Item>
                <Form.Item
                  name="descriptionRed"
                  label="Opis (nawozy dwuskładnikowe)"
                >
                  <TextEditor
                    initialValue={content2Value}
                    onChange={(value) => onContentEdit(value, 'descriptionRed')}
                    disableGallery
                  />
                </Form.Item>
              </fieldset>

              <fieldset className="fieldset no-bottom">
                <Form.Item
                  name="fileImage5"
                  label="Okładka (nawozy azotowe)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <FormCoverUpload
                    cover={fileImage5}
                    setCover={(e) =>
                      updateCover(
                        e,
                        'fileImage5',
                        setFileImage5,
                        changedFileImage5
                      )
                    }
                    isNew={fileImage5Changed}
                    id={form.getFieldsValue()?.id}
                    field="fileImage5"
                    number={5}
                    hideTags
                    dontResize
                  />
                </Form.Item>
                <Form.Item
                  name="fileDownloadBlue"
                  label="Plik do pobrania (nawozy azotowe)"
                >
                  <FormFileUpload
                    file={file3}
                    setFile={(e) =>
                      updateFile(e, 'fileDownloadBlue', setFile3, changedFile3)
                    }
                    id={form.getFieldsValue()?.id}
                    isNew={file3Changed}
                    field="file3"
                    number={3}
                  />
                </Form.Item>
                <Form.Item name="descriptionBlue" label="Opis (nawozy azotowe)">
                  <TextEditor
                    initialValue={content3Value}
                    onChange={(value) =>
                      onContentEdit(value, 'descriptionBlue')
                    }
                    disableGallery
                  />
                </Form.Item>
              </fieldset>

              <fieldset className="fieldset no-bottom">
                <Form.Item
                  name="fileImage6"
                  label="Okładka (nawozy azotowe z siarką)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <FormCoverUpload
                    cover={fileImage6}
                    setCover={(e) =>
                      updateCover(
                        e,
                        'fileImage6',
                        setFileImage6,
                        changedFileImage6
                      )
                    }
                    isNew={fileImage6Changed}
                    id={form.getFieldsValue()?.id}
                    field="fileImage6"
                    number={6}
                    hideTags
                    dontResize
                  />
                </Form.Item>
                <Form.Item
                  name="fileDownloadYellow"
                  label="Plik do pobrania (nawozy azotowe z siarką)"
                >
                  <FormFileUpload
                    file={file4}
                    setFile={(e) =>
                      updateFile(
                        e,
                        'fileDownloadYellow',
                        setFile4,
                        changedFile4
                      )
                    }
                    id={form.getFieldsValue()?.id}
                    isNew={file4Changed}
                    field="file4"
                    number={4}
                  />
                </Form.Item>
                <Form.Item
                  name="descriptionYellow"
                  label="Opis (nawozy azotowe z siarką)"
                >
                  <TextEditor
                    initialValue={content4Value}
                    onChange={(value) =>
                      onContentEdit(value, 'descriptionYellow')
                    }
                    disableGallery
                  />
                </Form.Item>
              </fieldset>

              <fieldset className="fieldset no-bottom">
                <Form.Item
                  name="fileImage7"
                  label="Okładka (nawozy wieloskładnikowe)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <FormCoverUpload
                    cover={fileImage7}
                    setCover={(e) =>
                      updateCover(
                        e,
                        'fileImage7',
                        setFileImage7,
                        changedFileImage7
                      )
                    }
                    isNew={fileImage7Changed}
                    id={form.getFieldsValue()?.id}
                    field="fileImage7"
                    number={7}
                    hideTags
                    dontResize
                  />
                </Form.Item>
                <Form.Item
                  name="fileDownloadGreen"
                  label="Plik do pobrania (nawozy wieloskładnikowe)"
                >
                  <FormFileUpload
                    file={file5}
                    setFile={(e) =>
                      updateFile(e, 'fileDownloadGreen', setFile5, changedFile5)
                    }
                    id={form.getFieldsValue()?.id}
                    isNew={file5Changed}
                    field="file5"
                    number={5}
                  />
                </Form.Item>
                <Form.Item
                  name="descriptionGreen"
                  label="Opis (nawozy wieloskładnikowe)"
                >
                  <TextEditor
                    initialValue={content5Value}
                    onChange={(value) =>
                      onContentEdit(value, 'descriptionGreen')
                    }
                    disableGallery
                  />
                </Form.Item>
              </fieldset>



              <Form.Item
                name="sortOrder"
                label="Kolejność"
                rules={[
                  {
                    required: true,
                  },
                  {
                    validator: async (_, value) => {
                      if (value) {
                        if (
                          (value.length > 5 ||
                            !/^[0-9]*\,?\.?[0-9]*$/.test(value)) &&
                          value.length > 0
                        ) {
                          return Promise.reject(
                            new Error('Proszę podać poprawną wartość!')
                          );
                        }
                      }
                    },
                  },
                ]}
              >
                <Input
                  style={{
                    width: '100px',
                  }}
                />
              </Form.Item>

              <div className="tables-collapse">
                <Collapse defaultActiveKey={[]}>
                  <Panel header="Tabelka 1" key="1" forceRender>
                    <Form.Item name="table1" label="Tabelka 1">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#1')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#1
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 2" key="2" forceRender>
                    <Form.Item name="table2" label="Tabelka 2">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#2')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#2
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 3" key="3" forceRender>
                    <Form.Item name="table3" label="Tabelka 3">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#3')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#3
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 4" key="4" forceRender>
                    <Form.Item name="table4" label="Tabelka 4">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#4')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#4
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 5" key="5" forceRender>
                    <Form.Item name="table5" label="Tabelka 5">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#5')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#5
                    </Button>
                  </Panel>
                </Collapse>
              </div>

              <ActivitySwitch isActivityDisabled={isActivityDisabled} />
              <Form.Item>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                  <Link to="/fertilization-schedule">
                    <Button>Powrót</Button>
                  </Link>
                </Space>
              </Form.Item>
            </Form>
          )}
          {loading && (
            <Link to="/fertilization-schedule">
              <Button>Powrót</Button>
            </Link>
          )}
          <BackTop />
        </div>
      </ConfigProvider>
    </>
  );
};

export default FertilizationScheduleEdit;
